import { createContext, useState } from "react";
import { COLOR_PALETTES, IMAGE_OPTIONS } from "../helpers";

export const ClassroomContext = createContext(null);

function randomWithinRange(max) {
  return Math.floor(Math.random() * max);
}

export function ClassroomContextProvider({ children }) {
  const [form, setForm] = useState({
    values: {
      color: randomWithinRange(COLOR_PALETTES.length),
      background_image_1:
        IMAGE_OPTIONS[randomWithinRange(IMAGE_OPTIONS.length)],
      background_image_2:
        IMAGE_OPTIONS[randomWithinRange(IMAGE_OPTIONS.length)],
      cause: [],
      damage: [],
      assessment: [],
      distinction: [],
      proportion: [],
      precaution: [],
    },
    touched: {},
  });

  const getField = (name) => form.values[name] ?? "";

  const setField = (name, value) => {
    form.values[name] = value;
    setForm({ ...form });
  };

  const setTouched = (name) => {
    form.touched[name] = true;
    setForm({ ...form });
  };

  const requireFields = (fields = []) => {
    return fields.every((name) => getField(name).length > 0);
  };

  const submitForm = () => setForm({ ...form });

  return (
    <ClassroomContext
      value={{
        form,
        getField,
        setField,
        submitForm,
        setTouched,
        requireFields,
      }}
    >
      {children}
    </ClassroomContext>
  );
}
